import { AxiosError, AxiosResponse } from 'axios';

import { eventCode, logKey, logLevel, traceOrigin } from '@/constants/trace-constant';
import { axios } from '@/plugins/axios';

/**
 * Service pour les appels API liés aux traces
 */
export class TraceApiService {

	/**
	 * Fait une trace dans les logs sur l'API
	 *
	 * @param code Code de l'évènement
	 * @param level (Optionnel) Niveau de la trace (ex : INFO, DEBUG, ...)
	 */
	public static trace(code: eventCode, level?: logLevel): Promise<AxiosResponse<void>> {
		const labels = new Map<logKey, string>([
			[logKey.EVENT_CODE, code],
			[logKey.ORIGIN, traceOrigin]
		]);

		return axios.post('traces'.concat(level ? `/?level=${level}` : ''), Object.fromEntries(labels))
			.then((response: AxiosResponse<void>) => response)
			.catch((error: AxiosError) => {
				throw new Error(error.message);
			});
	}
}
